import { Button } from "@/components/ui/button";
import { ReactNode, useState } from "react";
import {
  Dialog,
  DialogTrigger,
  DialogTitle,
  DialogHeader,
  DialogContent,
} from "@/components/ui/dialog";
import { CreateCustomerTierForm } from "./create-member-tier-form";

interface CreateMemberTierButtonProps {
  trigger?: ReactNode;
}

export function CreateMemberTierButton({
  trigger,
}: CreateMemberTierButtonProps) {
  const [isOpen, setIsOpen] = useState(false);

  const onSuccess = () => {
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        {trigger ?? (
          <Button variant="default" title="Create New Member Tier">
            Create Member Tier
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[800px]">
        <DialogHeader>
          <DialogTitle>Create New Member Tier</DialogTitle>
        </DialogHeader>
        <CreateCustomerTierForm onSuccess={onSuccess} />
      </DialogContent>
    </Dialog>
  );
}
